<template>
  <div>
    <ul class="work-list">
      <work-item
        v-for="work in filteredWorks"
        :key="work.id"
        :title="work.title"
        :id="work.id"
        :image="work.image"
        :short-description="work.shortDescription"
        :skills="work.skills"
      ></work-item>
    </ul>
    <div v-if="hiddenCount > 0" class="show-more">
      <base-button mode="call-to-action" @click="showAll = !showAll">
        {{ toggleLabel }}
      </base-button>
    </div>
  </div>
</template>

<script>
import WorkItem from '../../components/works/WorkItem.vue';
import BaseButton from '../../components/ui/BaseButton.vue';
export default {
  components: {
    WorkItem,
    BaseButton
  },
  data() {
    return {
      showAll: false
    };
  },
  computed: {
    allWorks() {
      return this.$store.getters['works/works'];
    },
    filteredWorks() {
      return this.showAll
        ? this.allWorks
        : this.allWorks.filter(work => work.featured);
    },
    hiddenCount() {
      return this.allWorks.filter(work => !work.featured).length;
    },
    toggleLabel() {
      return this.showAll
        ? 'Show fewer projects <'
        : `Show more projects (${this.hiddenCount}) >`;
    }
  }
};
</script>

<style lang="scss" scoped>
ul.work-list {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 5rem;

  @include respond(tab-port) {
    grid-template-columns: 1fr 1fr;
    grid-gap: 2.5rem;
  }
  @include respond(phone) {
    grid-template-columns: 1fr;
    row-gap: 2.5rem;
  }
}
.show-more {
  margin-top: 4rem;
}
</style>
